import request from '@/utils/request'
import host from '@/api/base/host'

// 课程分享
const share = host.path('loca:ljs', { module: 'share', dev: 'v1' })

export default {
  // 2022年05月27日
  // 邀请海报详情
  inviteShare(data) {
    return request({
      url: share('credit/invite/share'),
      method: 'post',
      data
    })
  },
  // 邀请列表
  inviteList(data) {
    return request({
      url: share('credit/invite/list'),
      method: 'post',
      data
    })
  },
  // 是否有邀请权限
  userAuth(data) {
    return request({
      url: share('credit/invite/userAuth'),
      method: 'post',
      data
    })
  },
  // 2022年05月27日end
  // 获取课程分享信息
  getCourseShareInfo(data) {
    return request({
      url: share('share/getCourseShareInfo'),
      method: 'post',
      data
    })
  },
  // 抢听
  shareParticipation(data) {
    return request({
      url: share('share/shareParticipation'),
      method: 'post',
      data
    })
  },
  // 获取录音分享信息
  getSoundRecordShareInfo(data) {
    return request({
      url: share('share/getSoundRecordShareInfo'),
      method: 'post',
      data
    })
  },
  // url解密
  getCourseUrl(data) {
    return request({
      url: share('goods/getCourseUrl'),
      method: 'post',
      data
    })
  },
  // 获取课程讲解详情
  getCourseExplainInfo(data) {
    return request({
      url: share('goods/getCourseExplainInfo'),
      method: 'post',
      data
    })
  },
  // 获取精彩互动列表
  getBeautifulInteract(data) {
    return request({
      url: share('user/learn/note/list'),
      method: 'post',
      data
    })
  },
  // 获取分享优惠券详情
  getShareCouponDetail(data) {
    return request({
      url: share('coupon/getCouponInfoById'),
      method: 'post',
      data
    })
  },
  // 领取优惠券
  obtainCoupon(data) {
    return request({
      url: share('coupon/obtainCoupon'),
      method: 'post',
      data
    })
  },
  // 分享课程详情
  getCourseDetail(data) {
    return request({
      url: share('share/getShareCourseInfo'),
      method: 'post',
      data
    })
  },
  // 通过用户身份跳转页面
  goLinkHref(data) {
    return request({
      url: share('forward/rule'),
      method: 'post',
      data
    })
  },
  // 体验营课程列表
  getCampList(data) {
    return request({
      url: share('goods/camp/list'),
      method: 'post',
      data
    })
  },
  getCourseCampList(data) {
    return request({
      url: share('goods/camp/courseList'),
      method: 'post',
      data
    })
  },
  getAlbumShareDetail(data) {
    return request({
      url: share('goods/album/share/detail'),
      method: 'post',
      data
    })
  }
}
